import { useCurrentOrg } from 'auth/hooks'
import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { useCallback } from 'react'
import { OrganizationLocationReporting } from 'locations/types'

export const useFetchOpportunityLocationByOpportunityOccurrence = () => {
  const organization = useCurrentOrg()
  const [request, { loading, error }] = useFetchRefactored<OrganizationLocationReporting>()

  const fetchLocation = useCallback(
    async (opportunityOccurrenceId: number) =>
      request({
        url: `/organizations/${organization.id}/opportunity-occurrences/${opportunityOccurrenceId}/opportunity-location`,
      }),
    [request, organization.id],
  )

  return { fetchLocation, loading, error }
}
